import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
	position: relative;
	width: 100%;
	padding: ${variables.sectionPadding};

	.headline {
		font-size: 1.7em;
		font-weight: 700;
		color: #262626;
		text-align: center;
		margin-bottom: 2em;
	}

	.options-selector {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 2em;
	}

	.layout-container {
		.control {
			margin-top: 2em;
		}
	}

	.offer-boxes {
		@keyframes fadeIn {
			0% {
				opacity: 0;
			}
			100% {
				opacity: 1;
			}
		}

		&__loader-container {
			display: flex;
			align-items: center;
			justify-content: center;
			height: 1100px;
		}

		.offer-boxes__not-found {
			text-align: center;
		}

		.offer-boxes-desktop {
			position: relative;
			display: flex;
			justify-content: flex-start;
			align-items: stretch;
			flex-wrap: wrap;
			width: 100%;
			animation: fadeIn 0.3s ease-in-out;

			> *:not(.layout-spinner):not(.offer-boxes__not-found) {
				width: calc(33.3% - 20px);
				margin: 10px;
				text-decoration: none;
				color: black;
			}
		}
	}

	@media all and (max-width: ${variables.desktopXS}) {
		.offer-boxes .offer-boxes-desktop {
			flex-wrap: wrap;

			> *:not(.layout-spinner):not(.offer-boxes__not-found) {
				width: calc(50% - 20px); 
			}
		}
	}

	@media all and (max-width: ${variables.tabletS}) {
		.offer-boxes .offer-boxes-desktop {
			> *:not(.layout-spinner):not(.offer-boxes__not-found) {
				width: calc(70%);
				margin: 2em auto;
			}
		}
	}

	@media all and (max-width: ${variables.mobileL}) {
		padding: ${variables.sectionPaddingMobile};
		overflow-x: hidden;

		.slick-list {
			padding: 0 !important;
		}

		.layout-container {
			width: 100%;

			.headline {
				padding: 0 5%;
			}
		}

		.options-selector {
			flex-wrap: wrap;

			> * {
				width: 100%;
				margin-bottom: 0.5em;
			}
		}

		.offer-boxes .offer-boxes-desktop {
			display: none;
		}
	}
`;
